import { prop, required } from '@rxweb/reactive-form-validators';

export class LayoutModel {
	@required()
	name: string;

	@prop({name: 'json_data'})
    json_data: string;

}
